import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-waterfall-transfers-banner',
  templateUrl: './waterfall-transfers-banner.component.html',
  styleUrls: ['./waterfall-transfers-banner.component.scss'],
  standalone: false,
})
export class WaterfallTransfersBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/settings', { section: 'calls' }]);
  }
}
